<template>
    <div class="app_container">
<!--        <el-card class="search-form-card" style="margin-top: 5px" v-if="type=='add'">-->
<!--            <el-form :inline="true" :model="form" class="search-form">-->
<!--                <el-form-item label="发布模板:" >-->
<!--                    <el-select v-model="depTemplateId" @change="getDepTemplate">-->
<!--                        <el-option v-for="item in depTemplateList" :key="item.id" :value="item.id" :label="item.title"></el-option>-->
<!--                    </el-select>-->
<!--                    <span style="margin-left: 20px;color: #1890ff;">建议使用模板简化您的操作&nbsp;(非必选)</span>-->
<!--                </el-form-item>-->
<!--            </el-form>-->
<!--        </el-card>-->
        <el-form :rules="rules" ref="form" :model="form" label-width="85px" class="event-form">
            <el-row v-if="type=='add'">
                <el-col :span="18">
                    <el-form-item label="发布模板" >
                        <el-select v-model="depTemplateId" @change="getDepTemplate">
                            <el-option v-for="item in depTemplateList" :key="item.id" :value="item.id" :label="item.title"></el-option>
                        </el-select>
                        <span style="margin-left: 20px;color: #1890ff;">建议使用模板简化您的操作&nbsp;(非必选)</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--所属公司  选择申请人-->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="所属公司" prop="company">
                        <el-select v-model="form.company" placeholder="请选择" filterable>
                            <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="申请人" >
                        <div>
                            <el-input type="text" placeholder="请选择申请人" disabled v-model="form.requester.name" class="form-common mr10"></el-input>
<!--                            <router-link :to="{ path:'/applicantList',query: { callback:getApplicant} }">-->
                            <router-link :to="{ path:'/requesterList',query: { enable:true, callback:getApplicant} }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                            <el-button type="primary" :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--发布类型  变更类别-->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="发布类型" prop="deployType">
                        <el-select v-model="form.deployType" placeholder="请选择" @change="changeTypeEvent">
                            <el-option v-for="item in deployType" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="变更类别" prop="deployClass">
                        <el-select v-model="form.deployClass" placeholder="请选择">
                            <el-option v-for="item in deployClass" :key="item.id" :label="item.cname"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 环境  发布时间 -->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="环境" prop="env">
                        <el-select v-model="form.env" placeholder="请选择" @change="envChangeEvent">
                            <el-option v-for="item in env" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="发布时间" prop="deployTime">
                        <el-date-picker
                            v-model="form.deployTime"
                            @change="deployTimeEvent"
                            type="datetime"
                            :picker-options="pickerOptions"
                            placeholder="选择日期时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            class="form-common">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="完成时间"  class="endTime" prop="endTime">
                        <el-date-picker
                            v-model="form.endTime"
                            type="datetime"
                            placeholder="选择日期时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="compareTime"
                            class="form-common"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--发布分类   涉及数据库-->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="发布分类" prop="category">
                        <el-select v-model="form.category" placeholder="请选择">
                            <el-option v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" class="database">
                    <el-form-item label="涉及数据库"  class="databaseTitle">
                        <el-select v-model="form.database" placeholder="请选择">
                            <el-option v-for="item in dataBaseList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--发布版本 -->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="发布版本" prop="version">
                        <el-input v-model="form.version" class="form-common"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--发布来源  编号-->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="发布来源" prop="deployOrigion">
                        <el-select v-model="form.deployOrigion" placeholder="请选择">
                            <el-option v-for="item in deployOrigion" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="type != 'add'">
                    <el-form-item label="编号">
                        <el-input type="text" disabled placeholder="请输入编号"
                                  class="common-input"
                                  v-model="form.serialNumber"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="项目名称" prop="projectName">
                        <el-select v-model="form.projectName" placeholder="请选择" filterable>
                            <el-option v-for="item in projectName" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="服务请求" prop="serviceClass">
                        <el-select v-model="form.serviceClass" placeholder="请选择" filterable>
                            <el-option v-for="item in serviceClass" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!--发布标题-->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="发布标题" prop="title">
                        <el-input v-model="form.title" class="form-common"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="风险等级" prop="risk">
                        <el-select v-model="form.risk" placeholder="请选择" >
                            <el-option v-for="item in risk" :key="item.id" :label="item.cname"
                                       :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--相关知识-->
            <el-row>
                <el-col :span="24">
                    <!-- 相关知识 -->
                    <div style="width:820px;float: right">
                        <knowledge ref="knowledge" :keyword="form.title" type="event"></knowledge>
                    </div>
                </el-col>
            </el-row>
            <!--优先级-->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="优先级" prop="priority">
                        <el-select v-model="form.priority" placeholder="请选择">
                            <el-option v-for="item in priority" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="紧急度" prop="emergency">
                        <el-select v-model="form.emergency" placeholder="请选择">
                            <el-option v-for="item in emergency" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

            </el-row>
            <!--详细描述-->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="详细描述" prop="description" >
                        <!-- <ueditor :description.sync="form.description" @getUeContent="getUeContent" ></ueditor> -->

                        <ueditor v-model="form.description" :config="myConfig" :key="1" :value="2" @ready="editorReady"></ueditor>
                    </el-form-item>
                </el-col>
            </el-row>

            <!--关联 事件\配置项\服务\变更-->
            <el-row>
                <el-col :span="6">
                    <el-form-item label="关联事件">
                        <router-link :to="{ path: '/relevancyEvent',query: { callback:relevancyEvent,data:form.toEvent }}">
                            <el-button type="primary">新增</el-button>
                        </router-link>
                        <relevancy-tab :data="form.toEvent" :getData="getEventData"></relevancy-tab>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="关联问题">
                        <router-link :to="{ path: '/relevancyProblem',query:{callback:relevancyProblem}}">
                            <el-button type="primary">新增</el-button>
                        </router-link>
                        <relevancy-tab :data="form.toProblem" :getData="getProblemData"></relevancy-tab>
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="关联变更">
                        <router-link :to="{ path: '/relevancyChange',query: { callback:relevancyChange }}">
                            <el-button type="primary">新增</el-button>
                        </router-link>
                        <relevancy-tab :data="form.toChange" :getData="getChangeData"></relevancy-tab>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="关联发布">
                        <router-link :to="{ path: '/relevancyDeploy',query: { callback:relevancyDeploy }}">
                            <el-button type="primary">新增</el-button>
                        </router-link>
                        <relevancy-tab :data="form.toDeploy" :getData="getDeployData"></relevancy-tab>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="关联服务">
                        <router-link :to="{ path: '/relevancyService',query:{callback:relevancyService}}">
                            <el-button type="primary">新增</el-button>
                        </router-link>
                        <relevancy-tab :data="form.toService" :getData="getServiceData"></relevancy-tab>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="关联配置项">
                        <router-link :to="{ path: '/relevancyConfig',query:{callback:relevancyConfig}}">
                            <el-button type="primary">新增</el-button>
                        </router-link>
                        <relevancy-tab :data="form.toCmdb" :getData="getCmdbData"></relevancy-tab>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--标签-->
            <el-row>
                <newTag :dadLabel="form.label" v-on:getLabelFromSon="getLabelFromSon"></newTag>
            </el-row>
            <!--上传附件-->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="附件">
                        <inputFile :data="attachment" :getFiles="getFiles"></inputFile>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--可交付结果\测试方案\失败应急方案\培训计划-->

                <el-form-item label="可交付结果">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="form.result">
                    </el-input>
                </el-form-item>
                <el-form-item label="测试方案">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="form.testPlan">
                    </el-input>
                </el-form-item>
                <el-form-item label="失败应急方案">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="form.failPlan">
                    </el-input>
                </el-form-item>
                <el-form-item label="培训计划">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="form.trainPlan">
                    </el-input>
                </el-form-item>
            <el-form-item v-if="type=='add'">
                <el-button type="primary" size="small" @click="submit('create_commit')" :disabled="isSubmit">{{ type == "edit" ? '确定' : "创建并提交"}}</el-button>
                <el-button type="primary" size="small" @click="submit('create')" :disabled="isSubmit">{{ type == "edit" ? '确定' : "创建"}}</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
            <el-form-item v-else>
                <el-button type="primary" size="small" @click="submit('create')" :disabled="isSubmit">{{ type == "edit" ? '确定' : ""}}</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
    import commonService from "../../services/common.service"
    import relevancyTab from "../common/relevancyTab.vue"
    import newTag from '../common/newTag'
    import services from "./deploy.service";
    import knowledge from "../../components/knowledge.vue"
    const VueUeditorWrap = window.VueUeditorWrap;
    import Config from "../../app.config";
    import ueditor from "../../components/ueditor.vue"
    import inputFile from "../common/inputFile.vue"
    import { getRules } from "./deploy.rules";
    const rules = getRules();
    const oneDayMs = 24 * 60 * 60 * 1000;
    export default {
        props: {
            type: {
                type: String,
                default: "add"
            },
            serialNumber: String,
            parentNumber: String,
            callback: Function,
            parentParams: Object,
        },
        components: {knowledge, ueditor, newTag, relevancyTab, inputFile},
        data() {
            return {
                pickerOptions: {
                  disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
                 }
                },
                formName: "form",
                form: {
                    company: "",
                    database: '',
                    category: '',
                    deployTime: "",      //发布时间

                    createUser: '',
                    requester: "",
                    deployType: "",//发布类型
                    deployClass: "",//变更类别
                    deployCategory: "",//发布分类
                    version: "",    //发布版本

                    deployOrigion: "",//发布来源
                    // deployTitle:"",//发布标题
                    description: "", //详细描述
                    // origin:"",
                    title: "",//发布标题
                    risk:"",
                    priority: "", //优先级
                    emergency:"",
                    label: [],
                    result: "",//交付结果
                    testPlan: "",//测试方案
                    failPlan: "",//失败应急方案
                    trainPlan: "",//培训计划
                    toEvent: [],
                    toChange: [],
                    toDeploy: [],
                    toProblem: [],
                    toCmdb: [],
                    toService: [],
                    projectName:'',
                    serviceClass:'',
                    env:'',
                },
                myConfig: {
                    autoHeightEnabled: false,
                    initialFrameHeight: 200,
                    initialFrameWidth: '100%',
                    UEDITOR_HOME_URL: '/UEditor/',
                    // serverUrl: 'http://35.201.165.105:8000/controller.php'/cr/v1/review
                    // serverUrl:Config.baseURL+"upload",
                    // serverUrl:'http://wedof.beta.autoai.com/upload/'
                    serverUrl:Config.BASE_API + "upload/",
                },
                editMode: true,
                department: "",//申请人部门信息
                // deployTime:"",      //发布时间
                applicantName: '',
                applicantId: '',
                attachment: [],    // 存放上传的附件
                companyList: [],   // 公司列表
                categoryList:[],  //发布分类
                dataBaseList: [],  //涉及数据库

                toEventId: [],     //
                toEventName: [],

                toChangeId: [],
                toChangeName: [],

                toProblemName: [],
                toProblemId: [],


                toDeployId: [],
                toDeployName: [],

                toConfigName: [],
                toConfigId: [],

                toServiceName: [],
                toServiceId: [],
                rules: rules,
                isKnowledge: false,
                userTasksTotal:'', //人员任务数
                isSubmit:false,
                depTemplateId:null,//新增时选择发布模板
                depTemplateList:[],
            }
        },
        created() {
            // console.log(this.dictionary,'字典');
            this.getCompanyList();
            this.getCategoryList();
            this.getDataBaseList();
            this.getDepTemplateList()
        },
        mounted(){
            if(this.type!=='edit'&&!this.parentNumber){
                // console.log(1);
                this.getDefaultUser()

            }
            if (this.type == "edit") {
                this.$modal.title = "修改发布"
                setTimeout(()=>{
                    this.getDetail();
                },100)
                // this.editMode = false
            }
            if (this.parentNumber) {
                this.$modal.title = '提交为发布'
                if (this.parentParams) {//由配置项提交为的时候
                    setTimeout(()=>{
                        this.getCmdbService()
                    },100)
                } else {
                    // console.log('uuu');
                    setTimeout(()=>{
                        this.getDetails()
                    },100)
                }
            }
        },
        computed: {
            dictionary() {
                return this.$store.state.dictionary;
            },
            //发布类型
            deployType() {
                return this.dictionary.deploy_type;
            },
            //变更类别
            deployClass() {
                return this.dictionary.deploy_class;
            },

            //发布分类
            // deployCategory() {
            //     return this.dictionary.deploy_category;
            // },
            deployTypeId(){
                return this.$store.state.caseType.deploy;
            },
            //发布来源
            deployOrigion() {
                return this.dictionary.deploy_origion;
            },

            // 优先级
            priority() {
                return this.dictionary.priority;
            },
            // 紧急度
            emergency(){
                return this.dictionary.emergency;
            },
            //风险等级
            risk(){
                return this.dictionary.deploy_risk
            },
            //环境
            env(){
                return this.dictionary.env
            },
            //项目名称
            projectName(){
                return this.dictionary.project_name
            },
            //服务请求
            serviceClass(){
                return this.dictionary.service_class
            },

        },
        methods: {
            //选择开始时间判断环境和发布类型
            deployTimeEvent(val){
                if(this.form.deployType =='' || this.form.env==''){
                    this.$message.error('请选择发布类型和环境，再选择发布时间')
                    this.form.deployTime=''
                }
            },
             //开始时间和完成时间的对比校验
            CompareDate(d1,d2) {
                //将所有的短横线替换为斜杠
                return ((new Date(d1.replace(/-/g,"\/"))) >= (new Date(d2.replace(/-/g,"\/"))));
            },
            compareTime(){
                let d1=this.form.deployTime?this.form.deployTime:''
                let d2=this.form.endTime?this.form.endTime:''
                if (this.form.deployTime&&this.form.endTime) {
                    let timeCompare=this.CompareDate(d1,d2)
                    if(timeCompare){
                        this.$message.error('完成时间应比开始时间晚，请重新选择')
                        this.form.endTime=''
                    }
                }


            },
            //发布类型事件
            changeTypeEvent(val){
                    //85紧急发布，83快速发布类型时间可以选当天开始
                    //81例行发布类型变更需要选择T+2之后的时间
                    this.envProFlag(this.form.env)
                    // if(val !== '83' && val !== '85') {
                    //     this.envProFlag(this.form.env)
                    // } else {
                    //     this.pickerOptions = {
                    //       disabledDate(time) {
                    //         return time.getTime() < Date.now() - 8.64e7;
                    //      }
                    //     }
                    // }
            },
            //环境事件
            envChangeEvent(val){
                this.form.deployTime = ''
                this.envProFlag(val)
            },
            //环境中文名判断是否为生产环境
            envProFlag(val){
                if(val !== ''){
                    // console.log('环境不为空')
                    this.env.map(item=>{
                        if(item.id == val){
                            var res = RegExp(/PRO/)
                            if(res.test(item.cname)){//生产
                                //例行、重大  + prod环境=T+2
                                if(this.form.deployType == '81'){
                                    this.pickerOptions = {
                                      disabledDate(time) {
                                        return time.getTime() < Date.now() + 8.64e7;
                                     }
                                    }
                                }else if(this.form.deployType == '83'){
                                    //快速
                                    this.pickerOptions = {
                                      disabledDate(time) {
                                        return time.getTime() < Date.now();
                                     }
                                    }

                                }else if(this.form.deployType == '85'){
                                    //紧急
                                    this.pickerOptions = {
                                      disabledDate(time) {
                                        return time.getTime() < Date.now() - 8.64e7;
                                     }
                                    }
                                }
                            }else{
                                // console.log('其他环境')
                                //非PROD环境=T+1
                                if(this.form.deployType == '85'){
                                    this.pickerOptions = {
                                      disabledDate(time) {
                                        return time.getTime() < Date.now() - 8.64e7;
                                     }
                                    }
                                }else{
                                    this.pickerOptions = {
                                      disabledDate(time) {
                                        return time.getTime() < Date.now();
                                     }
                                    }
                                }

                                //例行、重大  + 其他环境=T+1 (第二次需求)
                                // if(this.form.deployType == '81'){
                                //     this.pickerOptions = {
                                //       disabledDate(time) {
                                //         return time.getTime() < Date.now() + 8.64e7;
                                //      }
                                //     }
                                // }
                            }
                        }//最外层if  end
                    }) //===========mapend
                }else{
                    // console.log('环境为空')
                    if(this.form.deployType == 85){
                        this.pickerOptions = {
                            disabledDate(time) {
                                return time.getTime() < Date.now() - 8.64e7;
                            }
                        }
                    }else{
                        //环境为空并且类型为例行和重大
                        this.pickerOptions = {
                            disabledDate(time) {
                                return time.getTime() < Date.now();
                            }
                        }
                    }


                }

            },
            //获取发布分类
            getCategoryList(){
                commonService.categoryList(this.deployTypeId.id).then(res => {
                    this.categoryList = res;
                })
            },
            getLabelFromSon(val) {
                this.form.label = val
            },
            getDataBaseList() {
                commonService.dataBase().then(res => {
                    // console.log(res,'涉及数据库');
                    this.dataBaseList = res;
                })

            },
            // getUeContent(val) {
            //     this.form.description = val;
            // },
            editorReady (editorInstance) {
                editorInstance.setContent('你可以在这里初始化编辑器的初始内容。');
                let _this = this
                editorInstance.addListener('contentChange', () => {
                  // console.log('编辑器内容发生了变化:', editorInstance.getContent());getContentTxt()
                  // _this.form.Body = editorInstance.getContent()
                   _this.form.description = editorInstance.getContent()
                });
            },
            getFiles(val) {
                this.attachment = val;
            },
            submit(handleStr) {
                let formName = this.formName;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.isSubmit=true
                        if (this.parentParams) {
                            this.getRelevancyId()
                            let params = {
                                ...this.form,
                                createUser: window.localStorage.getItem('internalUserid'),
                                updateUser:window.localStorage.getItem('internalUserid'),
                                requester: this.applicantId,
                                toEvent: this.toEventId,          // 关联事件
                                toChange: this.toChangeId,        // 关联变更
                                toProblem: this.toProblemId,     // 关联问题
                                toDeploy: this.toDeployId,       // 关联发布
                                toCmdb: this.toConfigId,         // 关联配置项
                                toService: this.toServiceId,     // 关联服务
                            }
                            if (params.requester){
                                this.addDeploy(params)
                            } else{
                                this.isSubmit=false
                                this.$message.error('请选择申请人')
                            }

                        } else {
                            let params = this.getParams();
                            // console.log(params);
                            if (this.type == 'edit') {
                                this.updateDeploy(params);
                            } else {
                                params.handle = handleStr
                                this.addDeploy(params);
                            }
                        }

                    }else{
                        this.isSubmit=false
                        this.$message.error('✳为必填项，请全部填写')
                    }
                    ;
                    return valid;
                })
            },
            // 获取所属公司列表
            getCompanyList() {
                commonService.companyList().then(res => {
                    // console.log(res, '公司列表');
                    this.companyList = res.list;
                    // console.log(this.companyList);

                })
            },

            // 详情默认显示
            getDetail() {
                services.detail({serialNumber: this.serialNumber}).then(res => {
                    // console.log(res,'详情默认');
                    this.form = {...res};
                    this.form.category=+this.form.category

                    this.form.database=this.form.database?+this.form.database:""
                    this.attachment = res.attachment
                    this.applicantId = this.form.requester && this.form.requester.internalUserid
                    // console.log(this.form);
                    this.getRelevancyId()
                    this.getUserBusyness(this.applicantId )

                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            // 提交时详情默认显示
            getDetails() {
                commonService.getCorrectDetail({serialNumber: this.parentNumber}).then(res => {
                    // console.log(res,'提交时获取到的res');
                    this.form = {...res};
                    this.form.origin = "";
                    //当提交为发布时，只有从发布过来的才有正确的database，其他的都置空
                    let sn=this.parentNumber
                    if(sn.indexOf('Dep')>-1){
                       let database=res.database?+res.database:""
                        let category=+res.category
                        this.form={
                           ...this.form,
                            database:database,
                            category:category,

                        }
                    }else{
                        this.form.risk=""
                        this.form.category = "";
                        this.form.database=""
                    }
                    // this.form.database=+this.form.database
                    // let reqName = res.requester ? res.requester.name : ""
                    this.form.requester=res.requester ? res.requester :{}
                    this.applicantId = res.requester && res.requester.internalUserid
                    // console.log(this.applicantId,'ppppp');
                    this.attachment=this.form.attachment
                    this.getUserBusyness(this.applicantId)
                    // this.form.label =  res.label && res.label.join;
                    if (!res.label) {
                        this.form.label = []
                    }
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            getParams() {
                this.getRelevancyId()
                // console.log(this.applicantId);
                // console.log(this.form);
                let params = {
                    ...this.form,
                    // label:this.form.label.split(','),// 标签
                    database: this.form.database.toString(),
                    department:this.form.department.toString(),
                    // deployTime:this.form.deployTime,//发布时间
                    requester: this.applicantId,
                    createUser: this.type=='edit'?this.form.createUser:window.localStorage.getItem('internalUserid'),
                    attachment: this.attachment,      // 附件
                    updateUser:window.localStorage.getItem('internalUserid')?window.localStorage.getItem('internalUserid'):window.localStorage.getItem('internal_userid'),
                    toEvent: this.toEventId,          // 关联事件
                    toChange: this.toChangeId,       // 关联变更
                    toProblem: this.toProblemId,      // 关联问题
                    toDeploy: this.toDeployId,         // 关联发布
                    toCmdb: this.toConfigId,           // 关联配置项
                    toService: this.toServiceId,       // 关联服务
                };

                if (this.parentNumber) {
                    params.mainCase = this.parentNumber;
                }
                // console.log(params,'点击确定时传递的参数');
                ;
                return params;
            },
            getCmdbService() {
                this.form = {
                    ...this.form,
                    ...this.parentParams,
                    requester: "",
                    mainCase: this.parentNumber,
                }
                let toCmdb=this.parentParams.toCmdb.filter(item =>item.serialNumber===this.parentNumber)
                if (!toCmdb.length){
                    this.form.toCmdb.push({
                        serialNumber:this.parentNumber,
                        title: this.form.title
                    })
                }
                this.attachment = this.form.attachment
                this.getRelevancyId()
            },
            getRelevancyId() {
                this.toEventId = this.form.toEvent && this.form.toEvent.map(item => {
                    return item.serialNumber
                })
                this.toChangeId = this.form.toChange && this.form.toChange.map(item => {
                    return item.serialNumber
                })
                this.toProblemId = this.form.toProblem && this.form.toProblem.map(item => {
                    return item.serialNumber
                })
                this.toDeployId = this.form.toDeploy && this.form.toDeploy.map(item => {
                    return item.serialNumber
                });
                this.toConfigId = this.form.toCmdb && this.form.toCmdb.map(item => {
                    return item.serialNumber
                });
                ;
                this.toServiceId = this.form.toService && this.form.toService.map(item => {
                    return item.serialNumber
                })
            },
            // 创建发布
            addDeploy(params) {
                services.addDeploy(params).then(res => {
                    this.$message.success("发布创建成功");
                    this.close(true);
                }).catch(err => {
                    this.isSubmit=false
                    this.$message.error(err.message);
                })
            },
            // 修改发布
            updateDeploy(params) {
                // let params = this.form;

                services.updateDeploy(params).then(res => {
                    this.$message.success("发布修改成功");
                    this.close(true);
                }).catch(err => {
                    this.isSubmit=false
                    this.$message.error(err.message);
                })
            },
            // 公司--部分级联菜单
            // companyChange(value) {
            //     console.log(value,'value');
            //     this.form.company = value[0];
            //     this.form.department = value[1];
            // },
            getDepTemplateList(){
                services.getDepTemplateList({type:'deploy'}).then(res=>{
                    this.depTemplateList=res
                })
            },
            getDepTemplate(){
                // console.log(this.eventTemplateId);
                services.getDepTemplate(this.depTemplateId).then(res=>{
                    // console.log(res);
                    this.form={
                        ...this.form,
                        ...res.data
                    }
                    //给desscription添加一个后缀用以区分,这个后缀要具备唯一性
                    this.form.description=this.form.description+'万齐峻写的模板'
                    this.form.category = this.form.category?+this.form.category:''
                    // console.log(this.form.origin);
                    // this.attachment = res.attachment;
                    //选取模板后，请求人应该还是新增时默认的请求人信息
                    // this.form.requester = this.defaultUserInfo;
                    // this.applicantId = this.defaultUserInfo.internalUserid;
                    // this.form.department=this.defaultUserInfo.department
                    // this.getUserBusyness(this.applicantId)
                })
            },
            //新增时，报告人/申请人默认选取当前用户
            getDefaultUser(){
                let userId = window.localStorage.getItem('internalUserid')?window.localStorage.getItem('internalUserid'):window.localStorage.getItem('internal_userid')
                let params={
                    internalUserid:userId
                }
                // console.log(userId,'userId');
                commonService.getUserDetail(params).then(res =>{
                    // console.log(res);
                    for (let i in res){
                        this.defaultUserInfo=res[i]
                    }
                    // console.log(this.defaultUserInfo);
                    this.form.requester = this.defaultUserInfo;
                    this.applicantId = this.defaultUserInfo.internalUserid;
                    this.form.department=this.defaultUserInfo.department
                    this.getUserBusyness(this.applicantId)
                })

            },

            // 选择的申请人
            getApplicant(obj) {
                this.form={
                    ...this.form,
                    requester:obj,
                    department:obj.department.id
                }
                this.applicantId = obj.internalUserid

                this.getUserBusyness( this.applicantId )
            },
            getUserBusyness(id){
                services.busynessUser(id).then(res => {
                    this.userTasksTotal= res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            // 标题自动匹配知识库
            getKnowledge() {
                this.isKnowledge = this.form.title ? true : false;
            },

            //上传文件
            fileChange(e) {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    return;
                }
                ;
                this.form.attachment = files[0];
                let params = {
                    file_name: files[0]
                };
                commonService.uploading(params).then(res => {
                    let file = res;
                    this.attachment.push({
                        name: file.file_name,
                        url: file.download_url
                    })
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            onCancel() {
                // console.log('执行cancel')
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            },
            //选择完关联项后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{

                    if(!obj[item.serialNumber]){
                        obj[item.serialNumber]=1
                        newArr.push(item)

                    }
                })
                return newArr
            },
            // 获取选择后的关联的事件
            relevancyEvent(val) {
                this.form.toEvent =this.arrayUnique( this.form.toEvent.concat(val))
                val.forEach(item => {
                    this.toEventName.push(item.title);
                    this.toEventId.push(item.serialNumber);
                });
            },
            // 获取选择后的关联的变更
            relevancyChange(val) {
                this.form.toChange = this.arrayUnique(this.form.toChange.concat(val))
                val.forEach(item => {
                    this.toChangeName.push(item.title);
                    this.toChangeId.push(item.serialNumber);
                });
            },

            // 获取选择后的关联的发布
            relevancyDeploy(val) {
                this.form.toDeploy = this.arrayUnique(this.form.toDeploy.concat(val))
                val.forEach(item => {
                    this.toDeployName.push(item.title);
                    this.toDeployId.push(item.serialNumber);
                });
            },

            // 获取选择后的关联的问题
            relevancyProblem(val) {
                this.form.toProblem =this.arrayUnique( this.form.toProblem.concat(val))
                val.forEach(item => {
                    this.toProblemName.push(item.title);
                    this.toProblemId.push(item.serialNumber);
                });
            },
            //获取选择后的关联的配置项
            relevancyConfig(val) {
                this.form.toCmdb = this.arrayUnique(this.form.toCmdb.concat(val))
                // console.log(this.form.toCmdb);
                val.forEach(item => {
                    this.toConfigName.push(item.title);
                    this.toConfigId.push(item.serialNumber);
                });
            },
            //获取选择后的关联的服务
            relevancyService(val) {
                this.form.toService = this.arrayUnique(this.form.toService.concat(val))
                val.forEach(item => {
                    this.toServiceName.push(item.title);
                    this.toServiceId.push(item.serialNumber);

                });
            },
            getEventData(val) {
                this.form.toEvent = val;
            },
            getCmdbData(val) {
                this.form.toCmdb = val;
            },
            getServiceData(val) {
                this.form.toService = val;
            },
            getChangeData(val) {
                this.form.toChange = val;
            },
            getDeployData(val) {
                this.form.toDeploy = val;
            },
            getProblemData(val) {
                this.form.toProblem = val;
            },
        },

    }
</script>

<style  lang="scss"  rel="stylesheet/scss">

</style>
